import { BrandColors } from '../theme';
export const accordionTokens = {
    header: {
        color: BrandColors.semantic.text,
        fontWeight: '400',
        hoverColor: BrandColors.surface[700],
        padding: '12px 0'
    }
};
